/* LISTENING TO DRAG EVENT DIRECTION */
((d) => {
    var
        ce = (e, n) => {
            var a = document.createEvent("CustomEvent");
            a.initCustomEvent(n, true, true, e.target);
            e.target.dispatchEvent(a);
            a = null;
            return false
        },
        nm = true,
        sp = {
            x: 0,
            y: 0
        },
        ep = {
            x: 0,
            y: 0
        },
        touch = {
            touchstart: (e) => {
                sp = {
                    x: e.touches[0].pageX,
                    y: e.touches[0].pageY
                }
            },
            touchmove: (e) => {
                nm = false;
                ep = {
                    x: e.touches[0].pageX,
                    y: e.touches[0].pageY
                }
            },
            touchend: (e) => {
                if (nm) {
                    ce(e, 'fc')
                } else {
                    var x = ep.x - sp.x,
                        xr = Math.abs(x),
                        y = ep.y - sp.y,
                        yr = Math.abs(y);
                    if (Math.max(xr, yr) > 20) {
                        ce(e, (xr > yr ? (x < 0 ? 'swl' : 'swr') : (y < 0 ? 'swu' : 'swd')))
                    }
                };
                nm = true
            },
            touchcancel: (e) => {
                nm = false
            }
        };
    for (var a in touch) {
        d.addEventListener(a, touch[a], false);
    }
})(document);

/* LISTENING TO MOUSEWHEEL DIRECTION */
const wheelHandler = (e) => {
    return typeof e.wheelDelta != 'undefined' ? (e.wheelDelta < 0 ? true : false) : (e.detail < 0 ? false : true);
}

/* DISABLE HARD-REFRESH ON MOBILE */
window.addEventListener('load', function () {
    var preventPullToRefreshCheckbox = true;
    var preventOverscrollGlowCheckbox = false;
    var preventScrollCheckbox = false;

    var maybePreventPullToRefresh = false;
    var lastTouchY = 0;
    var touchstartHandler = function (e) {
        if (e.touches.length != 1) return;
        lastTouchY = e.touches[0].clientY;
        // Pull-to-refresh will only trigger if the scroll begins when the
        // document's Y offset is zero.
        maybePreventPullToRefresh =
            preventPullToRefreshCheckbox &&
            window.pageYOffset == 0;
    }

    var touchmoveHandler = function (e) {
        var touchY = e.touches[0].clientY;
        var touchYDelta = touchY - lastTouchY;
        lastTouchY = touchY;

        if (maybePreventPullToRefresh) {
            // To suppress pull-to-refresh it is sufficient to preventDefault the
            // first overscrolling touchmove.
            maybePreventPullToRefresh = false;
            if (touchYDelta > 0) {
                e.preventDefault();
                return;
            }
        }

        if (preventScrollCheckbox) {
            e.preventDefault();
            return;
        }

        if (preventOverscrollGlowCheckbox) {
            if (window.pageYOffset == 0 && touchYDelta > 0) {
                e.preventDefault();
                return;
            }
        }
    }

    window.document.addEventListener('touchstart', touchstartHandler, {
        passive: false
    });
    window.document.addEventListener('touchmove', touchmoveHandler, {
        passive: false
    });
});

/* LISTENING TO SWIPE EVENTS */
var touchStartCoords = {
        'x': -1,
        'y': -1
    }, // X and Y coordinates on mousedown or touchstart events.
    touchEndCoords = {
        'x': -1,
        'y': -1
    }, // X and Y coordinates on mouseup or touchend events.
    direction = 'undefined', // Swipe direction
    minDistanceXAxis = 30, // Min distance on mousemove or touchmove on the X axis
    maxDistanceYAxis = 30, // Max distance on mousemove or touchmove on the Y axis
    maxAllowedTime = 1000, // Max allowed time between swipeStart and swipeEnd
    startTime = 0, // Time on swipeStart
    elapsedTime = 0, // Elapsed time between swipeStart and swipeEnd
    targetElement = window.document // Element to delegate

function swipeStart(e) {
    e = e ? e : window.event;
    e = ('changedTouches' in e) ? e.changedTouches[0] : e;
    touchStartCoords = {
        'x': e.pageX,
        'y': e.pageY
    };
    startTime = new Date().getTime();
}

function swipeMove(e) {
    e = e ? e : window.event;
    e.preventDefault();
}

function swipeEnd(e, callback) {
    var _direction;
    e = e ? e : window.event;
    e = ('changedTouches' in e) ? e.changedTouches[0] : e;
    touchEndCoords = {
        'x': e.pageX - touchStartCoords.x,
        'y': e.pageY - touchStartCoords.y
    };
    elapsedTime = new Date().getTime() - startTime;
    if (elapsedTime <= maxAllowedTime) {
        if (Math.abs(touchEndCoords.x) >= minDistanceXAxis && Math.abs(touchEndCoords.y) <= maxDistanceYAxis) {
            direction = (touchEndCoords.x < 0) ? 'left' : 'right';
            switch (direction) {
                case 'left':
                    _direction = direction;
                    callback(false);
                    break;
                case 'right':
                    _direction = direction;
                    callback(true);
                    break;
            }
        }
    }
}

const addMultipleListeners = (el, s, fn) => {
    var evts = s.split(' ');
    for (var i = 0, iLen = evts.length; i < iLen; i++) {
        el.addEventListener(evts[i], fn, false);
    }
}

export {
    wheelHandler,
    addMultipleListeners,
    swipeEnd,
    swipeStart,
    swipeMove
}


// WEBPACK FOOTER //
// ./src/Components/Services/SwipeEvents.js